import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Alert } from '@/components';
import { IProcessedProfile } from '@/components/profileDetail';
import { Language, languageService } from '@/core/language';
import { LeadForm } from '@/pages/profile';
import { PopupTypes } from '@/pages/profile/lead/popupTypes';
import { LoginOption } from '@/pages/profile/loginOption';
import { withGlobalScrollForLeadForm } from '@/shared';
import { useStores } from '@/stores';

type PopupType =
  | PopupTypes.LoginOption
  | PopupTypes.Form
  | PopupTypes.Success
  | null;

const LeadPure: FC<{
  profile: IProcessedProfile;
  onAfterSignIn: () => void;
  onClose: () => void;
}> = ({ profile, onAfterSignIn, onClose }) => {
  const [popupType, setPopupType] = useState<PopupType>(null);

  const { userStore } = useStores();

  const showLeadForm = () => {
    setPopupType(PopupTypes.Form);
  };

  const handleSubmit = () => {
    setPopupType(PopupTypes.Success);
  };

  useEffect(() => {
    if (userStore.isLoggedIn) {
      showLeadForm();
    } else {
      setPopupType(PopupTypes.LoginOption);
    }
  }, []);

  return (
    <>
      {popupType === PopupTypes.LoginOption && (
        <LoginOption
          title={languageService.get(Language.LEAD_FORM_LOGIN_OPTION_TITLE)}
          onClose={onClose}
          onAfterSignIn={onAfterSignIn}
          onAsGuest={showLeadForm}
        />
      )}
      {popupType === PopupTypes.Form && (
        <LeadForm profile={profile} onSubmit={handleSubmit} onClose={onClose} />
      )}
      {popupType === PopupTypes.Success && (
        <Alert
          title={languageService.get(Language.TITLE_CONGRATULATIONS)}
          message={languageService.get(
            Language.LEAD_FORM_SUCCESSFUL_SUBMISSION,
          )}
          onClose={onClose}
        />
      )}
    </>
  );
};

export const Lead = withGlobalScrollForLeadForm(observer(LeadPure));
